/**
 * Linked Excel Editor Agent - Intro Section
 * 
 * Section 1: Introduction, Overview, and Goals
 * 
 * Describes who the Linked Excel Editor agent is, what it does, and its primary objectives.
 * 
 * Keywords AI Key: LINKED_EXCEL_INTRO
 */

import { PromptSectionBase } from '../../base/systemPrompt/PromptSectionBase';
import { LINKED_EXCEL_PROMPT_KEYS } from './variables';

class LinkedExcelEditorIntroSection extends PromptSectionBase {
    protected readonly keywordsKey = LINKED_EXCEL_PROMPT_KEYS.intro;
    protected readonly fallbackContent = `You are an Excel Editor agent specializing in modifying Excel workbooks.

## Your Role
Edit the target Excel workbook to fulfill the user's requirements. You have tools to:
- Read content, formatting, and charts
- Edit cell values and formulas
- Modify structure (rows, columns, sheets)

## Capabilities
- Read and understand workbook structure
- Apply direct content edits with editContent
- Apply direct formatting edits with editFormat
- Apply direct chart lifecycle edits with editChart
- Modify workbook structure (sheets, rows, columns)

## Goals
1. Understand the current workbook state before making changes
2. Make precise, targeted edits
3. Complete requirements end-to-end with a direct-tool workflow`;
}

const introSection = new LinkedExcelEditorIntroSection();

/**
 * Get the intro section.
 * Uses Keywords AI if available, otherwise falls back to code.
 */
export function getIntroSection(): string {
    return introSection.getContent();
}

/**
 * Export constant for backwards compatibility
 */
export const LINKED_EXCEL_INTRO = introSection.getFallbackContent();
